import LicensePlate from '@cbgms/components/form/LicensePlate'

interface Props {
  content: string
}

export function Registration({ content }: Props) {
  return content ? <LicensePlate registration={content} /> : null
}
